import { underlineLinkStyle } from './shared-styles-from-theme-fluent';
import { uurlTestToolStyle } from './uurl-test-tool-style';

export const advancedSettingsSectionStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }, { advancedSectionMarginLeft = 38 } = {}) => ({

  '& .advanced-settings-section, .adschedule-targets-container, .bid-adjustments-container, .audience-advanced-settings-section, .settings-top-grid-panel-container': {

    '& .bidBoost-percentValue': {
      width: 66,
      marginRight: 8,
    },

    padding: '8px 0 20px 0',
    borderTop: `1px solid ${palette.neutralSecondary}`,

    '& .col-sm-10>div': {
      marginBottom: 20,
    },

    '& .table>thead>tr>th': {
      verticalAlign: 'top',
      textAlign: 'left',
      border: `1px solid ${palette.neutralLight}`,
      fontWeight: 'normal',
    },

    '& .table>tbody>tr>td': {
      verticalAlign: 'middle',
      padding: '0 10px',
      height: 42,
      border: `1px solid ${palette.neutralLight}`,
    },

    '& .table__row--indent td:first-child': {
      paddingLeft: '32px !important',
    },

    '& .table>thead>tr>th span': {
      display: 'inline-block',
      maxWidth: '80%',
    },

    '& #setAdvancedSettings .form-group': {
      marginLeft: advancedSectionMarginLeft,
    },

    '& #setAdvancedSettings .form-group:nth-child(2)>label': {
      marginTop: 0,
    },

    '& #setAdvancedSettings': {
      '& div[data-bind="visible: showNativeAds()"], & div[data-bind="visible: showMultimediaAds()"], & div[data-bind="visible: showAdDistribution()"], & div[data-bind="visible: showAdRotation()"], & div[data-bind="visible: showLocationTargets()"], & div[data-bind="visible: showAdSchedule()"], & div[data-bind="visible: showDeviceTargets()"]': {
        '&>.form-control-static': {
          minHeight: 1,

          '&>a:not(.helpbutton)': {
            '&, &[aria-expanded="false"], &.collapsed': {
              textDecoration: 'none',
              outline: 'none',
              border: 'none',
              color: palette.themePrimary,
              lineHeight: '24px',
              fontSize: 14,

              '&:before': {
                content: '"\\E76C"',
                fontFamily: iconFontFamily,
                marginRight: 8,
                position: 'relative',
                top: 2,
              },

              '&:hover': {
                color: palette.themeDarker,
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
              },

              '&:focus': {
                color: palette.themeDarker,
                border: `1px solid ${palette.neutralSecondary}`,
              },
            },

            '&[aria-expanded="true"]:before': {
              content: '"\\E70D"',
            },
          },
        },
      },
    },

    '& .expanderImage, .expandedImage': {
      fontSize: 18,
      marginRight: 11,
    },

    '& .form-control-static': {
      margin: '3px 0',
      padding: 0,
      minHeight: 'fit-content',
      color: palette.neutralSecondary,
      marginBottom: '3px !important',
    },

    ...uurlTestToolStyle({ palette, iconFontFamily }),

    /** *************Ad schedule begin******* */

    '& .ad-schedule, .adschedule-targets, .advanced-scheduling-grid': {

      '&.show-cashback-percent': {
        '& .ad-scheduling-grid': {
          minWidth: 1200,
        },
      },

      '& .date-settings__container': {

        '& .date-settings-intro': {
          padding: 0,
        },

        '& .date-container': {
          '& table ': {
            height: 200,
            width: 500,
            position: 'relative',


            '& td': {
              position: 'absolute',
              width: '100%',
            },

            '& .schedule-item-label': {
              fontWeight: 600,
              color: '#323130',
            },

            '& tr:nth-child(1)': {
              height: 92,

              '& td:nth-child(2)': {
                top: 26,
              },
            },

            '& tr:nth-child(2)': {
              '& td:nth-child(2)': {
                marginTop: 25,

                '& .radio': {
                  padding: 0,

                  '& .col-sm-3': {
                    width: 'auto',
                    marginTop: 5,

                    '& label': {
                      paddingTop: 0,
                      paddingBottom: 0,
                    },
                  },

                  '& .col-sm-9': {
                    width: 'auto',
                  },
                },

                '& .radio.row': {
                  padding: [8, 5, 8, 8],
                  left: -8,
                  position: 'relative',
                  width: 'fit-content',

                  '&:focus-within': {
                    outline: `1px solid ${palette.neutralSecondary}`,
                  },
                },
              },
            },

            '& .date-start, & .date-end': {
              width: '220px !important',
            },

          },
        },

      },

      '& .k-select': {
        display: 'none',
      },

      '& td>.col-sm-9': {
        padding: 0,
      },
      '& td>.radio': {
        width: 'auto',
      },

      '& .scheduling-grid': {
        marginTop: 46,
        marginBottom: 32,
        minWidth: 918,
      },
      '& .new-advance-target-grid-container': {
        marginBottom: 12,
      },

      '& .ad-scheduling-grid': {
        minWidth: 918,
        '& thead>tr': {
          '& th.cashback-percent-head': {
            width: 200,
          },
        },

        '& tbody>tr': {
          '& td:nth-child(2), td:nth-child(5),td:nth-child(8)': {
            borderRight: '0 !important',
          },

          '& td.cashback-percent-cell': {
            borderLeft: '0 !important',
            paddingLeft: 0,
            '& input.form-control': {
              width: 64,
              display: 'inline-block',
              marginRight: 10,
            },
          },

          '& td:nth-child(3), td:nth-child(6), td:nth-child(9)': {
            borderRight: '0 !important',
            borderLeft: '0 !important',
            padding: '0 !important',
          },

          '& td:nth-child(4), td:nth-child(7), td:nth-child(10)': {
            borderLeft: '0 !important',
          },

          '& td.cashback-percent-options-cell': {
            borderRight: '0 !important',
          },
        },
      },

      '& .ad-scheduling-panel': {

        '& table': {
          position: 'relative',

          '& tr': {
            verticalAlign: 'top',
          },
          '& tr:nth-child(2)': {
            '& a': {
              padding: [0, 8],
              marginBottom: 29,
              left: -8,
              position: 'relative',
              display: 'inline-block',
            },
          },

          '& tr:nth-child(3)': {
            position: 'relative',
            height: 85,

            '& td': {
              position: 'relative',
              '& span': {
                color: '#323130',
                fontWeight: 600,
              },

              '& .radio-inline:nth-child(2)': {
                position: 'absolute',
                top: 20,
              },

              '& .radio-inline:nth-child(3)': {
                position: 'absolute',
                top: 50,
                margin: 0,
              },
            },
          },

          '& tr:nth-child(4)': {
            '& .schedule-item-label': {
              color: '#323130',
              fontWeight: 600,
              lineHeight: '19px',
            },
            '& .radio': {
              padding: 0,
            },
            '& .schedule-timezone-setting-text': {
              paddingLeft: 28,
            },
          },
        },

        '& .table>tbody tr:nth-child(3) span': {
          marginRight: 20,
        },
      },
    },

    /** *************device begin******* */
    '& .device-targets, table[target-type="Device"], table[target-type="OriginalDevice"]': {
      width: 716,
      '&.showCashbackPercent': {
        width: 800,
        '& thead th': {
          '&.col-sm-3, &.col-sm-4': {
            width: 'auto',
          },
          // '&:nth-child(1)': {
          //   width: 130,
          // },
          // '&.cashback-percent-head': {
          //   width: 370,
          // },
        },
        '& tbody tr td:nth-child(3)': {
          width: 125,
        },
        '& .cashback-option-select-col': {
          width: 200,
        },
        '& tbody td.cashback-option-select-col': {
          borderRight: 'none',
          '& select': {
            display: 'block',
          },
        },
        '& tbody td.cashback-value-col': {
          paddingLeft: 0,
          width: 160,
          borderLeft: 'none',
          '& .inherit-cashback-value': {
            display: 'block',
          },
          '& input': {
            width: 64,
            display: 'inline-block',
            marginRight: 10,
          },
        },
      },

      '& table>tbody, tbody': {
        '& tr>td[colspan="3"]': {
          height: 'auto',

          '& ul': {
            marginBottom: 0,
            minHeight: 42,

            '& li': {
              height: 42,
              lineHeight: '42px',
            },
          },
        },

        '& tr>td:nth-child(2)': {
          borderRight: 0,
          paddingRight: 0,
          width: '1%',
          '& select': {
            width: 135,
          },
          '& select:focus': {
            border: `1px solid ${palette.neutralSecondary}`,
          },
        },

        '& tr>td:nth-child(3)': {
          borderLeft: 0,
          '& input': {
            width: 66,
          },
        },

        '& tr>td:nth-child(4)': {
          '& input': {
            width: 66,
            marginRight: 10,
          },
        },
      },

      '& .bidBoost-percentValue, .bidBoost-percent': {
        marginRight: 8,
      },
    },

    '& .advance-targeting-grid, demographic-gender-targets': {
      width: 716,

      '& table>tbody, tbody': {
        '& tr>td[colspan="3"]': {
          height: 'auto',
        },
      },
    },

    /** *************Ad distribution begin******* */
    '& #setAdDistributionSettings ': {
      '& .infomark': {
        display: 'none',
      },

      '& .radio > div': {
        marginLeft: 30,
        '& span': {
          ...underlineLinkStyle({ palette, elementLocator: '> a.HelpTopic' }),
        },
      },

    },

    /** *************Audience ads begin******* */
    '& #setNativeAdsSettings, #setMultimediaAdsSettings': {
      '& .advance-targeting-grid': {
        '& thead>tr': {
          '& th:nth-child(1)': {
            width: 'auto',
          },

          '& th:nth-child(2)': {
            width: 'auto',
          },
        },

        '& tbody>tr': {
          '& td:nth-child(1)': {
            width: 'auto',
          },

          '& td:nth-child(2)': {
            borderRight: 0,
            padding: '0 0 0 8px',
            width: 142,

            '& select': {
              width: 135,
            },
          },

          '& td:nth-child(3)': {
            borderLeft: 0,
            padding: '0 0 0 8px',

            '& .bidBoost-percentValue': {
              marginRight: 8,
              width: 66,
            },
          },

          '& td:nth-child(4)': {
            '& .cashback-percent-value': {
              width: 66,
              marginRight: 10,
            },
          },
        },

        '& td[colspan="3"]': {
          height: 'auto',
          borderBottom: 0,
          padding: 0,

          '& ul': {
            marginBottom: 0,
            minHeight: 42,
            borderBottom: `1px solid ${palette.neutralLight}`,
            padding: '0 10px',

            '& li': {
              height: 42,
              lineHeight: '42px',
            },
          },
        },
      },
    },

    '& #setAdDistributionSettings': {
      '& .ad-distribution-info': {
        margin: '8px 0px',
      },
    },

    '& .form-control[disabled]': {
      background: '#F3F2F1',
      border: 'none',
      color: '#A19F9D',
    },
  },

  '& .advanced-settings-section>div>.form-horizontal>.form-group>a': {
    fontSize: 18,
    marginBottom: 15,
  },

  '& .advanced-settings-section a[data-target="#setAdvancedSettings"], .audience-advanced-settings-header': {
    backgroundClip: 'content-box',

    '&:hover': {
      border: 'none',
      textDecoration: 'none',
      backgroundColor: '#F3F2F1',
    },

    '&:focus': {
      border: '1px solid',
      borderColor: palette.neutralSecondary,
      textDecoration: 'none',
      outline: 'none',
      marginLeft: '15px',
      paddingLeft: '0px',
      width: 'calc(100% - 30px)',
    },
  },

  '& table[target-type="OriginalDevice"]': {
    '& tr': {
      '&.deviceSettings.target': {
        '& .checkbox input.targetDevice': {
          position: 'static',
          marginLeft: 10,
          display: 'inline-block',
          verticalAlign: 'middle',
        },

        '& td>div:last-child .link': {
          verticalAlign: 'middle',
        },
      },

      '& .bidBoost-options': {
        width: 97,
        marginRight: 8,
      },

      '& .bidBoost-percentValue': {
        width: 66,
        marginRight: 8,
      },
    },
  },
});
